"use strict";

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _actions = require("./redux/actions");

var _selectors = require("./redux/selectors");

var _BannerGroup = _interopRequireDefault(require("./BannerGroup"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var RightRegion = function RightRegion(_ref) {
  var id = _ref.id,
      collapsed = _ref.collapsed,
      bannerGroups = _ref.bannerGroups,
      createBannerGroup = _ref.createBannerGroup,
      toggleCollapse = _ref.toggleCollapse;
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "RightRegion"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "card mb-4"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "card-header"
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "btn btn-sm btn-outline-secondary btn-icon mr-3 ".concat(collapsed ? 'collapsed' : ''),
      type: "button",
      onClick: function onClick() {
        return toggleCollapse('Menu', id, 'right');
      },
      "aria-expanded": "true",
      "aria-controls": "#right-region-card-body-".concat(id)
    },
    /*#__PURE__*/
    _react["default"].createElement("i", {
      className: "material-icons"
    }, "expand_more")), "Right Region",
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "btn btn-sm btn-primary btn-icon float-right",
      onClick: function onClick() {
        return createBannerGroup({
          menuId: id,
          region: 'right'
        });
      },
      title: "Add Banner Group"
    },
    /*#__PURE__*/
    _react["default"].createElement("i", {
      className: "material-icons"
    }, "add"))),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "card-body collapse ".concat(!collapsed ? 'show' : ''),
      id: "right-region-card-body-".concat(id)
    }, bannerGroups.map(function (bannerGroup, i) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_BannerGroup["default"], _extends({
          key: "BannerGroup-".concat(bannerGroup.id),
          index: i
        }, bannerGroup))
      );
    }))))
  );
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var id = _ref2.id;
  return {
    bannerGroups: (0, _selectors.getBannerGroupsInRightRegion)(state, id)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  createBannerGroup: _actions.createBannerGroup,
  toggleCollapse: _actions.toggleCollapse
})(RightRegion);

exports["default"] = _default;